import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=248d2710&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=ts&"
export * from "./ClientList.vue?vue&type=script&lang=ts&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=248d2710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d2710",
  null
  
)

/* custom blocks */
import block0 from "./ClientList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports